/* tslint:disable */
/* eslint-disable */
/**
 * Onbaording Buffetti Api
 * Onbaording Buffetti Api Specification
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: gianluca.stefanelli@linksmt.it
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { CheckboxFieldFromJSON, CheckboxFieldToJSON, } from './CheckboxField';
import { PosTerminalFromJSON, PosTerminalToJSON, } from './PosTerminal';
import { RadioboxFieldFromJSON, RadioboxFieldToJSON, } from './RadioboxField';
import { StringFieldFromJSON, StringFieldToJSON, } from './StringField';
/**
 * Check if a given object implements the PaymentFacilitatorSection interface.
 */
export function instanceOfPaymentFacilitatorSection(value) {
    let isInstance = true;
    return isInstance;
}
export function PaymentFacilitatorSectionFromJSON(json) {
    return PaymentFacilitatorSectionFromJSONTyped(json, false);
}
export function PaymentFacilitatorSectionFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'posTerminals': !exists(json, 'posTerminals') ? undefined : (json['posTerminals'].map(PosTerminalFromJSON)),
        'posAcquiring': !exists(json, 'posAcquiring') ? undefined : CheckboxFieldFromJSON(json['posAcquiring']),
        'posBuyOption': !exists(json, 'posBuyOption') ? undefined : RadioboxFieldFromJSON(json['posBuyOption']),
        'posRentalOption': !exists(json, 'posRentalOption') ? undefined : RadioboxFieldFromJSON(json['posRentalOption']),
        'posScaffaleOption': !exists(json, 'posScaffaleOption') ? undefined : RadioboxFieldFromJSON(json['posScaffaleOption']),
        'visaCardsCreditConsumer': !exists(json, 'VisaCardsCreditConsumer') ? undefined : StringFieldFromJSON(json['VisaCardsCreditConsumer']),
        'visaCardsDebitConsumePrepaid': !exists(json, 'VisaCardsDebitConsumePrepaid') ? undefined : StringFieldFromJSON(json['VisaCardsDebitConsumePrepaid']),
        'visaCorporate': !exists(json, 'VisaCorporate') ? undefined : StringFieldFromJSON(json['VisaCorporate']),
        'visaCardsEletronVisaCardsCreditConsumer': !exists(json, 'VisaCardsEletronVisaCardsCreditConsumer') ? undefined : StringFieldFromJSON(json['VisaCardsEletronVisaCardsCreditConsumer']),
        'visaCardsEletronVisaCardsDebitConsumePrepaid': !exists(json, 'VisaCardsEletronVisaCardsDebitConsumePrepaid') ? undefined : StringFieldFromJSON(json['VisaCardsEletronVisaCardsDebitConsumePrepaid']),
        'vPayDebitConsumePrepaid': !exists(json, 'VPayDebitConsumePrepaid') ? undefined : StringFieldFromJSON(json['VPayDebitConsumePrepaid']),
        'masterCardCreditConsumer': !exists(json, 'MasterCardCreditConsumer') ? undefined : StringFieldFromJSON(json['MasterCardCreditConsumer']),
        'masterCardDebitConsumePrepaid': !exists(json, 'MasterCardDebitConsumePrepaid') ? undefined : StringFieldFromJSON(json['MasterCardDebitConsumePrepaid']),
        'masterCardyCorporate': !exists(json, 'MasterCardyCorporate') ? undefined : StringFieldFromJSON(json['MasterCardyCorporate']),
        'maestroDebitConsumerPrepaid': !exists(json, 'MaestroDebitConsumerPrepaid') ? undefined : StringFieldFromJSON(json['MaestroDebitConsumerPrepaid']),
        'pagoBancoMatDebitConsumerPrepaid': !exists(json, 'PagoBancoMatDebitConsumerPrepaid') ? undefined : StringFieldFromJSON(json['PagoBancoMatDebitConsumerPrepaid']),
        'eEACreditConsumer': !exists(json, 'EEACreditConsumer') ? undefined : StringFieldFromJSON(json['EEACreditConsumer']),
        'eEADebitCosumer': !exists(json, 'EEADebitCosumer') ? undefined : StringFieldFromJSON(json['EEADebitCosumer']),
        'eEACreditBusiness': !exists(json, 'EEACreditBusiness') ? undefined : StringFieldFromJSON(json['EEACreditBusiness']),
        'gatewayPOS': !exists(json, 'GatewayPOS') ? undefined : StringFieldFromJSON(json['GatewayPOS']),
        'bluetooth': !exists(json, 'Bluetooth') ? undefined : StringFieldFromJSON(json['Bluetooth']),
        'setupPOS': !exists(json, 'SetupPOS') ? undefined : StringFieldFromJSON(json['SetupPOS']),
        'onSiteAssistance': !exists(json, 'OnSiteAssistance') ? undefined : StringFieldFromJSON(json['OnSiteAssistance']),
        'uninstallCost': !exists(json, 'UninstallCost') ? undefined : StringFieldFromJSON(json['UninstallCost']),
        'noReturnCost': !exists(json, 'NoReturnCost') ? undefined : StringFieldFromJSON(json['NoReturnCost']),
        'onsiteAssistance2': !exists(json, 'OnsiteAssistance2') ? undefined : StringFieldFromJSON(json['OnsiteAssistance2']),
        'estatement': !exists(json, 'Estatement') ? undefined : StringFieldFromJSON(json['Estatement']),
        'statement': !exists(json, 'Statement') ? undefined : StringFieldFromJSON(json['Statement']),
        'eAdditionalInfo': !exists(json, 'EAdditionalInfo') ? undefined : StringFieldFromJSON(json['EAdditionalInfo']),
        'additionalInfo': !exists(json, 'AdditionalInfo') ? undefined : StringFieldFromJSON(json['AdditionalInfo']),
        'surcharge': !exists(json, 'Surcharge') ? undefined : StringFieldFromJSON(json['Surcharge']),
        'disputeCost': !exists(json, 'DisputeCost') ? undefined : StringFieldFromJSON(json['DisputeCost']),
        'acquiringFee': !exists(json, 'AcquiringFee') ? undefined : StringFieldFromJSON(json['AcquiringFee']),
        'cloudFee': !exists(json, 'CloudFee') ? undefined : StringFieldFromJSON(json['CloudFee']),
        'replacementPOS': !exists(json, 'ReplacementPOS') ? undefined : StringFieldFromJSON(json['ReplacementPOS']),
        'sIMActivation': !exists(json, 'SIMActivation') ? undefined : StringFieldFromJSON(json['SIMActivation']),
        'sIMFee': !exists(json, 'SIMFee') ? undefined : StringFieldFromJSON(json['SIMFee']),
        'hUBUSB': !exists(json, 'HUBUSB') ? undefined : StringFieldFromJSON(json['HUBUSB']),
        'surchargeSIM': !exists(json, 'SurchargeSIM') ? undefined : StringFieldFromJSON(json['SurchargeSIM']),
    };
}
export function PaymentFacilitatorSectionToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'posTerminals': value.posTerminals === undefined ? undefined : (value.posTerminals.map(PosTerminalToJSON)),
        'posAcquiring': CheckboxFieldToJSON(value.posAcquiring),
        'posBuyOption': RadioboxFieldToJSON(value.posBuyOption),
        'posRentalOption': RadioboxFieldToJSON(value.posRentalOption),
        'posScaffaleOption': RadioboxFieldToJSON(value.posScaffaleOption),
        'VisaCardsCreditConsumer': StringFieldToJSON(value.visaCardsCreditConsumer),
        'VisaCardsDebitConsumePrepaid': StringFieldToJSON(value.visaCardsDebitConsumePrepaid),
        'VisaCorporate': StringFieldToJSON(value.visaCorporate),
        'VisaCardsEletronVisaCardsCreditConsumer': StringFieldToJSON(value.visaCardsEletronVisaCardsCreditConsumer),
        'VisaCardsEletronVisaCardsDebitConsumePrepaid': StringFieldToJSON(value.visaCardsEletronVisaCardsDebitConsumePrepaid),
        'VPayDebitConsumePrepaid': StringFieldToJSON(value.vPayDebitConsumePrepaid),
        'MasterCardCreditConsumer': StringFieldToJSON(value.masterCardCreditConsumer),
        'MasterCardDebitConsumePrepaid': StringFieldToJSON(value.masterCardDebitConsumePrepaid),
        'MasterCardyCorporate': StringFieldToJSON(value.masterCardyCorporate),
        'MaestroDebitConsumerPrepaid': StringFieldToJSON(value.maestroDebitConsumerPrepaid),
        'PagoBancoMatDebitConsumerPrepaid': StringFieldToJSON(value.pagoBancoMatDebitConsumerPrepaid),
        'EEACreditConsumer': StringFieldToJSON(value.eEACreditConsumer),
        'EEADebitCosumer': StringFieldToJSON(value.eEADebitCosumer),
        'EEACreditBusiness': StringFieldToJSON(value.eEACreditBusiness),
        'GatewayPOS': StringFieldToJSON(value.gatewayPOS),
        'Bluetooth': StringFieldToJSON(value.bluetooth),
        'SetupPOS': StringFieldToJSON(value.setupPOS),
        'OnSiteAssistance': StringFieldToJSON(value.onSiteAssistance),
        'UninstallCost': StringFieldToJSON(value.uninstallCost),
        'NoReturnCost': StringFieldToJSON(value.noReturnCost),
        'OnsiteAssistance2': StringFieldToJSON(value.onsiteAssistance2),
        'Estatement': StringFieldToJSON(value.estatement),
        'Statement': StringFieldToJSON(value.statement),
        'EAdditionalInfo': StringFieldToJSON(value.eAdditionalInfo),
        'AdditionalInfo': StringFieldToJSON(value.additionalInfo),
        'Surcharge': StringFieldToJSON(value.surcharge),
        'DisputeCost': StringFieldToJSON(value.disputeCost),
        'AcquiringFee': StringFieldToJSON(value.acquiringFee),
        'CloudFee': StringFieldToJSON(value.cloudFee),
        'ReplacementPOS': StringFieldToJSON(value.replacementPOS),
        'SIMActivation': StringFieldToJSON(value.sIMActivation),
        'SIMFee': StringFieldToJSON(value.sIMFee),
        'HUBUSB': StringFieldToJSON(value.hUBUSB),
        'SurchargeSIM': StringFieldToJSON(value.surchargeSIM),
    };
}
